const createEvent = ({
  value,
  name
}) => ({ target: { value, name } });
export {
  createEvent
};
//# sourceMappingURL=createEvent.js.map
